export var PagePath;
(function (PagePath) {
    PagePath["DASHBOARD"] = "/";
    PagePath["TABLES"] = "/tables";
    // 會員
    PagePath["MEMBERS"] = "/members";
    PagePath["CHECK_IN"] = "/check-in";
    PagePath["MEMBERS_IMPORT"] = "/members/import";
    PagePath["MEMBERS_BRAVE_RANKING"] = "/members/brave-ranking";
    PagePath["ADMIN_ASSOCIATION_PROMOTION"] = "/admin/association-promotion";
    // 帳務
    PagePath["ACCOUNTING_OPEN"] = "/accounting/open";
    PagePath["ACCOUNTING_EXPENSES"] = "/accounting/expenses";
    PagePath["ACCOUNTING_SETTLE"] = "/accounting/settle";
    PagePath["ACCOUNTING_REPORT"] = "/accounting/report";
    // 錦標賽
    PagePath["TOURNAMENT"] = "/tournament";
    PagePath["TOURNAMENT_CREATE"] = "/tournament/create";
    PagePath["TOURNAMENT_CALENDAR"] = "/tournament/calendar";
    PagePath["TOURNAMENT_BLIND_STRUCTURES"] = "/tournament/blind-structures";
    PagePath["TOURNAMENT_TIMED_SETTLEMENT_LEVELS"] = "/tournament/timed-settlement-levels";
    PagePath["TOURNAMENT_TIMED_FEE_PLANS"] = "/tournament/timed-fee-plans";
    PagePath["TOURNAMENT_TEMPLATES"] = "/tournament/templates";
    PagePath["TOURNAMENT_PAYOUT_RULES"] = "/tournament/payout-rules";
    // 電視顯示
    PagePath["DISPLAY"] = "/display";
    // 系統管理
    PagePath["ADMIN_USERS"] = "/admin/users";
    PagePath["ADMIN_ROLES"] = "/admin/roles";
    PagePath["ADMIN_LOGS"] = "/admin/logs";
    PagePath["ADMIN_TERMINOLOGY"] = "/admin/terminology";
    PagePath["ADMIN_EMAIL_SETTINGS"] = "/admin/email-settings";
    PagePath["ADMIN_POINTS_CONFIG"] = "/admin/points-config";
    PagePath["ADMIN_VENUE"] = "/admin/venue";
    PagePath["ADMIN_TIMER_PREVIEW"] = "/admin/timer-preview";
    PagePath["ADMIN_BRANDING"] = "/admin/branding";
    PagePath["ADMIN_MEMBER_PORTAL_EDITOR"] = "/admin/member-portal-editor";
    PagePath["ADMIN_VENUES"] = "/admin/venues";
    PagePath["ADMIN_PAGE_SETTINGS"] = "/admin/page-settings";
    PagePath["ADMIN_TV_APP"] = "/admin/tv-app";
    PagePath["ADMIN_DEV_TOOLS"] = "/admin/dev-tools";
})(PagePath || (PagePath = {}));
// Navigation is the canonical configurable-page catalog. Runtime guards remain separate.
export const PAGE_NAVIGATION = [
    {
        labelKey: 'nav.dashboard',
        iconKey: 'dashboard',
        defaultIcon: '⊞',
        pagePath: PagePath.DASHBOARD,
        requiredFeature: 'report.advanced',
    },
    {
        labelKey: 'nav.tables',
        iconKey: 'tables',
        defaultIcon: '🎲',
        pagePath: PagePath.TABLES,
        requiredFeature: 'floor.console',
    },
    {
        labelKey: 'nav.members',
        iconKey: 'members',
        defaultIcon: '👥',
        children: [
            {
                labelKey: 'nav.memberList',
                pagePath: PagePath.MEMBERS,
                requiredFeature: 'member.enabled',
                iconKey: 'memberList',
                defaultIcon: 'address-book',
            },
            {
                labelKey: 'nav.braveRanking',
                pagePath: PagePath.MEMBERS_BRAVE_RANKING,
                requiredFeature: 'member.enabled',
                iconKey: 'braveRanking',
                defaultIcon: 'trophy',
            },
            {
                labelKey: 'nav.checkIn',
                pagePath: PagePath.CHECK_IN,
                requiredFeature: 'member.enabled',
                iconKey: 'checkIn',
                defaultIcon: '✅',
            },
            {
                labelKey: 'nav.batchImport',
                pagePath: PagePath.MEMBERS_IMPORT,
                requiredFeature: 'member.enabled',
                iconKey: 'batchImport',
                defaultIcon: '📥',
            },
            {
                labelKey: 'nav.tierConfig',
                pagePath: PagePath.ADMIN_POINTS_CONFIG,
                requiredFeature: 'member.points',
                iconKey: 'tierConfig',
                defaultIcon: '⭐',
            },
            {
                labelKey: 'nav.associationPromotion',
                pagePath: PagePath.ADMIN_ASSOCIATION_PROMOTION,
                requiredFeature: 'member.enabled',
                iconKey: 'associationPromotion',
                defaultIcon: 'settings',
            },
            {
                labelKey: 'nav.memberPortalEditor',
                pagePath: PagePath.ADMIN_MEMBER_PORTAL_EDITOR,
                requiredFeature: 'member.enabled',
                iconKey: 'memberPortalEditor',
                defaultIcon: '▣',
            },
        ],
    },
    {
        labelKey: 'nav.accounting',
        iconKey: 'accounting',
        defaultIcon: '💰',
        children: [
            {
                labelKey: 'nav.accountingOpen',
                pagePath: PagePath.ACCOUNTING_OPEN,
                requiredFeature: 'accounting.enabled',
                iconKey: 'accountingOpen',
                defaultIcon: '🔓',
            },
            {
                labelKey: 'nav.accountingExpenses',
                pagePath: PagePath.ACCOUNTING_EXPENSES,
                requiredFeature: 'accounting.enabled',
                iconKey: 'accountingExpenses',
                defaultIcon: '📝',
            },
            {
                labelKey: 'nav.accountingSettle',
                pagePath: PagePath.ACCOUNTING_SETTLE,
                requiredFeature: 'accounting.enabled',
                iconKey: 'accountingSettle',
                defaultIcon: '🧾',
            },
            {
                labelKey: 'nav.accountingReport',
                pagePath: PagePath.ACCOUNTING_REPORT,
                requiredFeature: 'accounting.enabled',
                iconKey: 'accountingReport',
                defaultIcon: '🖨️',
            },
        ],
    },
    {
        labelKey: 'nav.tournament',
        iconKey: 'tournament',
        defaultIcon: '🏆',
        children: [
            {
                labelKey: 'nav.tournamentCreate',
                pagePath: PagePath.TOURNAMENT_CREATE,
                iconKey: 'tournamentCreate',
                defaultIcon: '➕',
            },
            {
                labelKey: 'nav.tournamentList',
                pagePath: PagePath.TOURNAMENT,
                iconKey: 'tournamentList',
                defaultIcon: '📋',
            },
            {
                labelKey: 'nav.tournamentCalendar',
                pagePath: PagePath.TOURNAMENT_CALENDAR,
                iconKey: 'tournamentCalendar',
                defaultIcon: '📅',
            },
            {
                labelKey: 'nav.blindStructures',
                pagePath: PagePath.TOURNAMENT_BLIND_STRUCTURES,
                iconKey: 'blindStructures',
                defaultIcon: 'stairs-up',
            },
            {
                labelKey: 'nav.timedSettlementLevels',
                pagePath: PagePath.TOURNAMENT_TIMED_SETTLEMENT_LEVELS,
                iconKey: 'timedSettlementLevels',
                defaultIcon: 'clock-dollar',
            },
            {
                labelKey: 'nav.payoutRules',
                pagePath: PagePath.TOURNAMENT_PAYOUT_RULES,
                iconKey: 'payoutRules',
                defaultIcon: '％',
            },
            {
                labelKey: 'nav.timedFeePlans',
                pagePath: PagePath.TOURNAMENT_TIMED_FEE_PLANS,
                iconKey: 'timedFeePlans',
                defaultIcon: 'clock-dollar',
            },
            {
                labelKey: 'nav.tournamentTemplates',
                pagePath: PagePath.TOURNAMENT_TEMPLATES,
                iconKey: 'tournamentTemplates',
                defaultIcon: '📄',
            },
        ],
    },
    {
        labelKey: 'nav.tvDisplay',
        iconKey: 'tvDisplay',
        defaultIcon: '📺',
        pagePath: PagePath.DISPLAY,
    },
    {
        labelKey: 'nav.system',
        iconKey: 'system',
        defaultIcon: '⚙️',
        children: [
            {
                labelKey: 'nav.users',
                pagePath: PagePath.ADMIN_USERS,
                requiredFeature: 'auth.multi-user',
                iconKey: 'users',
                defaultIcon: 'user-cog',
            },
            {
                labelKey: 'nav.roles',
                pagePath: PagePath.ADMIN_ROLES,
                requiredFeature: 'auth.rbac',
                iconKey: 'roles',
                defaultIcon: '🔐',
            },
            {
                labelKey: 'nav.venueManagement',
                pagePath: PagePath.ADMIN_VENUES,
                iconKey: 'venues',
                defaultIcon: '🏢',
            },
            {
                labelKey: 'nav.venueSettings',
                pagePath: PagePath.ADMIN_VENUE,
                requiredFeature: 'branding.theme',
                iconKey: 'venueSettings',
                defaultIcon: 'adjustments',
            },
            {
                labelKey: 'nav.timerPreview',
                pagePath: PagePath.ADMIN_TIMER_PREVIEW,
                requiredFeature: 'display.layout-editor',
                iconKey: 'timerPreview',
                defaultIcon: '⏱️',
            },
            {
                labelKey: 'nav.branding',
                pagePath: PagePath.ADMIN_BRANDING,
                requiredFeature: 'branding.logo',
                iconKey: 'branding',
                defaultIcon: '🎨',
            },
            {
                labelKey: 'nav.pageSettings',
                pagePath: PagePath.ADMIN_PAGE_SETTINGS,
                requiredFeature: 'auth.rbac',
                iconKey: 'pageSettings',
                defaultIcon: 'layout-sidebar',
            },
            {
                labelKey: 'nav.tvApp',
                pagePath: PagePath.ADMIN_TV_APP,
                requiredFeature: 'branding.logo',
                iconKey: 'tvApp',
                defaultIcon: 'package',
            },
            {
                labelKey: 'nav.terminology',
                pagePath: PagePath.ADMIN_TERMINOLOGY,
                requiredFeature: 'i18n.custom-terms',
                iconKey: 'terminology',
                defaultIcon: '🌐',
            },
            {
                labelKey: 'nav.emailSettings',
                pagePath: PagePath.ADMIN_EMAIL_SETTINGS,
                requiredFeature: 'accounting.email-send',
                iconKey: 'emailSettings',
                defaultIcon: '📧',
            },
            {
                labelKey: 'nav.devTools',
                pagePath: PagePath.ADMIN_DEV_TOOLS,
                requiredFeature: 'report.advanced',
                iconKey: 'devTools',
                defaultIcon: 'code',
            },
            {
                labelKey: 'nav.logs',
                pagePath: PagePath.ADMIN_LOGS,
                requiredFeature: 'report.advanced',
                iconKey: 'logs',
                defaultIcon: '📜',
            },
        ],
    },
];
export const PAGE_CATALOG = PAGE_NAVIGATION.flatMap((entry) => entry.pagePath ? [{ ...entry, pagePath: entry.pagePath }] : (entry.children ?? []));
export const ALL_PAGE_PATHS = PAGE_CATALOG.map((page) => page.pagePath);
export const PAGE_FEATURE_MAP = Object.fromEntries(PAGE_CATALOG.filter((page) => page.requiredFeature).map((page) => [
    page.pagePath,
    page.requiredFeature,
]));
export const SIDEBAR_DEFINITION = PAGE_NAVIGATION.map((entry) => ({
    type: entry.pagePath ? 'single' : 'group',
    labelKey: entry.labelKey,
    ...(entry.pagePath
        ? { pagePath: entry.pagePath }
        : { children: entry.children.map(({ pagePath, labelKey }) => ({ pagePath, labelKey })) }),
}));
export function getConfigurablePages(hasFeature) {
    return PAGE_CATALOG.filter((page) => !hasFeature || !page.requiredFeature || hasFeature(page.requiredFeature));
}
export function missingPagePaths(existing) {
    const known = new Set(existing);
    return ALL_PAGE_PATHS.filter((path) => !known.has(path));
}
//# sourceMappingURL=page-catalog.js.map